export const categories = [
  { id: "gaoxiao", name: "搞笑猫咪", slug: "gaoxiao", description: "让人捧腹大笑的猫咪搞笑视频合集，猫咪出糗、猫咪恶作剧、猫咪搞笑行为大全" },
  { id: "mengchong", name: "萌宠日常", slug: "mengchong", description: "记录猫咪日常生活点滴，可爱瞬间、温馨互动、猫咪与主人的美好时光" },
  { id: "duanpian", name: "萌猫短片", slug: "duanpian", description: "精心制作的猫咪创意短片，有剧情、有故事、有趣味的高质量猫咪短视频" },
  { id: "zhiyu", name: "治愈猫咪", slug: "zhiyu", description: "温暖治愈的猫咪视频，让心灵得到抚慰，压力瞬间释放的猫咪治愈合集" },
  { id: "youmao", name: "幼猫成长", slug: "youmao", description: "见证小奶猫从出生到长大的全过程，记录幼猫成长的每一个可爱瞬间" },
  { id: "catknowledge", name: "养猫知识", slug: "catknowledge", description: "铲屎官必备的养猫攻略，从喂养到护理，帮你成为合格的猫咪家长" },
];

export const articles = [
  {
    id: 1,
    title: "猫咪偷偷打开冰箱偷吃零食，被抓包后表情亮了",
    slug: "cat-steals-snacks-from-fridge",
    category: "gaoxiao",
    excerpt: "一只机智的橘猫趁着主人不注意，偷偷学会了打开冰箱门，熟练地叼出小鱼干，结果被主人撞见时那一脸无辜的表情让网友笑翻了。",
    content: "最近，一段橘猫偷吃零食的视频在社交媒体上爆火。视频中，一只圆滚滚的橘猫趁着主人不在厨房，熟练地用爪子扒开冰箱门，然后探进半个身子叼出了一袋小鱼干。正当它准备大快朵颐时，主人突然出现，猫咪瞬间石化，嘴里还叼着小鱼干，露出了一脸无辜的表情，仿佛在说「这不是我干的」。\n\n这段视频上传后迅速获得了超过百万的播放量，网友们纷纷评论：「这演技可以去拿奥斯卡了」「猫咪的表情管理绝了」「它是在用生命演戏」。\n\n专家表示，猫咪具有很强的好奇心和学习能力，一些聪明的猫咪确实能够通过观察学会打开简单的门把手和抽屉。建议铲屎官们将食物妥善存放，避免猫咪误食不适合的食物。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20chubby%20orange%20tabby%20cat%20with%20an%20innocent%20expression%20caught%20stealing%20fish%20snacks%20from%20an%20open%20refrigerator%20warm%20kitchen%20lighting%20soft%20cream%20and%20beige%20background%20editorial%20pet%20photography%20with%20shallow%20depth%20of%20field%20clean%20minimalist%20composition%20warm%20and%20cozy%20atmosphere&width=800&height=450&seq=article-cat-steals-snacks&orientation=landscape",
    date: "2026-08-08",
    readTime: "3分钟",
    views: 128000,
    tags: ["搞笑", "橘猫", "偷吃"],
    featured: true,
  },
  {
    id: 2,
    title: "布偶猫每天早上准时叫醒主人，方式太暖了",
    slug: "ragdoll-cat-wakes-owner",
    category: "mengchong",
    excerpt: "一只布偶猫养成了每天早上7点准时叫醒主人的习惯，但它不是用爪子拍脸，也不是大声喵喵叫，而是用最温柔的方式……",
    content: "对于很多铲屎官来说，被猫咪用爪子拍脸叫醒是家常便饭。但这位网友家的布偶猫却有着与众不同的叫醒方式——每天早晨7点整，它会轻轻跳上床，然后用毛茸茸的脑袋蹭主人的脸颊，发出轻柔的咕噜声。\n\n主人分享道：「它从来不会用爪子，也不会大声叫，就是用最温柔的方式让我醒来。有时候我装睡，它就会安静地蜷缩在我枕头旁边等我。」\n\n这段温馨的日常视频打动了无数网友，很多人表示「看了这个视频感觉一天都美好了」「这就是养猫的意义」「布偶猫真的是天使猫咪」。\n\n兽医建议，猫咪如果养成了固定的作息习惯，铲屎官可以适当配合，但同时也要确保猫咪的饮食和活动时间合理分配。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20fluffy%20ragdoll%20cat%20with%20blue%20eyes%20gently%20nuzzling%20a%20sleeping%20persons%20cheek%20on%20a%20soft%20white%20bed%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20warm%20golden%20hour%20lighting%20cozy%20bedroom%20atmosphere%20soft%20cream%20and%20blush%20tones%20editorial%20pet%20photography%20with%20dreamy%20aesthetic&width=800&height=450&seq=article-ragdoll-wakes-owner&orientation=landscape",
    date: "2026-08-07",
    readTime: "4分钟",
    views: 96000,
    tags: ["布偶猫", "温馨", "日常"],
    featured: true,
  },
  {
    id: 3,
    title: "流浪猫变身记：从瘦骨嶙峋到圆滚滚的蜕变",
    slug: "stray-cat-transformation",
    category: "zhiyu",
    excerpt: "一位好心人救助了一只骨瘦如柴的流浪猫，经过三个月的精心照顾，这只猫咪的变化让所有人感动落泪。",
    content: "三个月前，一位网友在小区楼下发现了一只骨瘦如柴的流浪猫，它的肋骨清晰可见，毛发脏乱打结，眼神中充满了恐惧。这位网友决定把它带回家。\n\n第一个月，猫咪非常警惕，总是躲在沙发底下。主人每天定时放置食物和水，轻声跟它说话。慢慢地，猫咪开始愿意出来吃东西，也开始接受抚摸。\n\n第二个月，猫咪的体重明显增加，毛发开始变得有光泽。它开始主动蹭主人的腿，晚上也会跳上床睡觉。\n\n第三个月，这只曾经瘦骨嶙峋的流浪猫已经变成了一只圆滚滚、毛发光亮的漂亮猫咪。视频记录了它从第一天到第九十天的每一个变化，让无数网友感动。\n\n「每个生命都值得被温柔对待」「看到它现在的样子我真的哭了」「谢谢你给了它一个家」——这些是评论区最常见的留言。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20heartwarming%20before%20and%20after%20scene%20of%20a%20rescued%20stray%20cat%20left%20side%20showing%20a%20thin%20timid%20cat%20right%20side%20showing%20the%20same%20cat%20now%20healthy%20and%20fluffy%20with%20bright%20eyes%20soft%20warm%20cream%20background%20clean%20minimalist%20split%20composition%20emotional%20and%20uplifting%20pet%20rescue%20photography%20soft%20natural%20lighting&width=800&height=450&seq=article-stray-cat-transform&orientation=landscape",
    date: "2026-08-06",
    readTime: "5分钟",
    views: 256000,
    tags: ["流浪猫", "救助", "感动"],
    featured: true,
  },
  {
    id: 4,
    title: "猫咪和仓鼠的跨物种友谊，这画面太美了",
    slug: "cat-and-hamster-friendship",
    category: "duanpian",
    excerpt: "谁说猫和鼠一定是天敌？这只猫咪和小仓鼠的友谊故事，颠覆了所有人的认知。",
    content: "在大多数人的印象中，猫和老鼠是天生的敌人。但这只名叫团团的英短蓝猫和它的仓鼠小伙伴球球，却建立了令人惊讶的深厚友谊。\n\n主人精心拍摄了这部短片，记录了两只小动物从初次见面时的谨慎试探，到慢慢接受彼此，再到如今形影不离的全过程。\n\n视频中最打动人的一幕是：仓鼠从笼子里跑出来后，猫咪没有追逐它，而是轻轻地用鼻子碰了碰仓鼠，然后躺下来让仓鼠爬到自己身上玩耍。\n\n这部短片在网络上获得了超过500万的播放量，被多个国际动物媒体转载报道。网友们纷纷表示：「这是我看过最治愈的视频」「动物之间的友谊太纯粹了」「打破了我们对猫的刻板印象」。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20grey%20British%20shorthair%20cat%20lying%20peacefully%20on%20a%20soft%20cream%20blanket%20while%20a%20tiny%20hamster%20sits%20on%20its%20paw%20warm%20studio%20lighting%20soft%20focus%20background%20in%20warm%20peachy%20tones%20heartwarming%20and%20magical%20atmosphere%20professional%20pet%20photography%20with%20dreamy%20aesthetic%20and%20gentle%20composition&width=600&height=400&seq=article-cat-hamster&orientation=landscape",
    date: "2026-08-05",
    readTime: "4分钟",
    views: 189000,
    tags: ["英短", "仓鼠", "跨物种"],
    featured: false,
  },
  {
    id: 5,
    title: "小奶猫第一次吃猫粮，反应萌翻全网",
    slug: "kitten-first-meal",
    category: "youmao",
    excerpt: "刚满月的小奶猫第一次尝试固体食物，那笨拙又认真的吃相让网友们直呼「太可爱了」。",
    content: "铲屎官记录下了自家刚满月的小奶猫第一次尝试猫粮的全过程。视频中，这只毛茸茸的小家伙先是好奇地闻了闻面前的猫粮碗，然后用小爪子试探性地碰了一下。\n\n最搞笑的是，小猫尝试咬猫粮的时候，因为颗粒对于它来说还有点大，它歪着脑袋努力咀嚼的样子萌翻了所有观众。吃着吃着，它居然把头埋进了碗里，弄得满脸都是猫粮碎屑。\n\n这段视频一经发布就迅速走红，累计播放量突破800万。网友评论：「我血槽已空」「这个小家伙是在用生命卖萌」「看它吃东西我能看一整天」。\n\n宠物营养师提醒，幼猫在断奶期需要选择专门针对幼猫阶段设计的猫粮，颗粒大小要适合，营养成分要全面，才能支持小猫的健康成长。",
    imageUrl: "https://readdy.ai/api/search-image?query=An%20adorable%20tiny%20fluffy%20kitten%20with%20food%20crumbs%20on%20its%20face%20trying%20to%20eat%20from%20a%20small%20bowl%20for%20the%20first%20time%20soft%20warm%20morning%20light%20from%20window%20cream%20colored%20cozy%20home%20setting%20shallow%20depth%20of%20field%20cute%20and%20heartwarming%20pet%20photography%20with%20soft%20peachy%20tones%20and%20clean%20background&width=800&height=450&seq=article-kitten-first-meal&orientation=landscape",
    date: "2026-08-04",
    readTime: "3分钟",
    views: 312000,
    tags: ["幼猫", "萌宠", "成长"],
    featured: true,
  },
  {
    id: 6,
    title: "新手铲屎官必看：猫咪到家第一周该做什么",
    slug: "new-cat-owner-first-week",
    category: "catknowledge",
    excerpt: "刚接回一只小猫咪不知道该怎么办？这份超详细的猫咪到家第一周攻略请收好，帮你顺利度过磨合期。",
    content: "恭喜你成为铲屎官！猫咪到家第一周是非常关键的适应期，合理的安排能让猫咪更快融入新家。\n\n第一天：给猫咪一个安静的小空间，准备好猫砂盆、食物和水。不要急着抱它，让它自己探索。猫咪可能会躲起来，这是正常的。\n\n第二到三天：保持环境安静，定时喂食，轻声跟猫咪说话。可以用逗猫棒尝试互动，但不要强迫。\n\n第四到五天：猫咪开始适应环境后，可以逐步扩大它的活动范围。这时候可以尝试轻轻抚摸它。\n\n第六到七天：大部分猫咪这时候已经基本适应了。可以开始建立喂食和玩耍的规律，也可以安排第一次兽医检查。\n\n兽医提醒：到新家一周内不要给猫咪洗澡，也不要换猫粮品牌。如果猫咪出现持续的食欲不振、腹泻或精神萎靡，请及时就医。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20corner%20setup%20with%20cat%20essentials%20including%20a%20soft%20cat%20bed%20litter%20box%20food%20bowls%20and%20scratching%20post%20a%20curious%20kitten%20peeking%20out%20from%20behind%20warm%20natural%20lighting%20cream%20and%20sage%20green%20interior%20tones%20clean%20minimalist%20home%20decor%20photography%20welcoming%20and%20educational%20atmosphere&width=600&height=400&seq=article-new-cat-guide&orientation=landscape",
    date: "2026-08-03",
    readTime: "6分钟",
    views: 45000,
    tags: ["新手", "攻略", "养猫"],
    featured: false,
  },
  {
    id: 7,
    title: "猫咪听到洗澡二字瞬间消失，反应速度堪比闪电",
    slug: "cat-hates-bath-time",
    category: "gaoxiao",
    excerpt: "只要主人说出「洗澡」两个字，原本懒洋洋躺着的猫咪立刻消失得无影无踪，这反应速度让主人哭笑不得。",
    content: "你家猫咪害怕洗澡吗？这位铲屎官家的猫咪对「洗澡」二字的敏感程度简直令人惊叹。视频中，主人只是在打电话时无意提到了「今天要给猫咪洗澡」，原本在沙发上悠闲舔毛的猫咪立刻竖起耳朵，然后以迅雷不及掩耳之势钻进了沙发底下。\n\n主人尝试了各种方式——变换语调、用不同语言、甚至只是做出「洗」的口型，猫咪都能准确识别并迅速逃跑。网友们笑称：「这只猫上辈子可能是语言学家」「它是在脑子里装了个关键词识别系统吧」「我家猫也是一样的，听到洗澡两个字比听到罐头声跑得还快」。\n\n宠物行为专家解释，猫咪对特定词汇形成条件反射是正常的。如果猫咪对洗澡有强烈的抗拒，建议使用干洗喷雾或者逐步脱敏训练来改善。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20funny%20scene%20of%20a%20tabby%20cat%20with%20wide%20startled%20eyes%20mid%20run%20diving%20behind%20a%20sofa%20motion%20blur%20effect%20showing%20speed%20warm%20living%20room%20with%20soft%20cream%20and%20beige%20tones%20humorous%20and%20dynamic%20pet%20action%20photography%20clean%20modern%20interior%20background%20playful%20atmosphere&width=600&height=400&seq=article-cat-hates-bath&orientation=landscape",
    date: "2026-08-02",
    readTime: "3分钟",
    views: 178000,
    tags: ["搞笑", "洗澡", "逃跑"],
    featured: false,
  },
  {
    id: 8,
    title: "猫咪每天陪主人练瑜伽，动作比主人还标准",
    slug: "cat-does-yoga-with-owner",
    category: "mengchong",
    excerpt: "一只猫咪养成了每天陪主人做瑜伽的习惯，它模仿主人的动作有模有样，某些伸展动作甚至比主人做得还要标准。",
    content: "瑜伽爱好者小美发现自家的暹罗猫对瑜伽垫有着特别的喜爱。每次她铺开瑜伽垫，猫咪就会准时出现在旁边，跟着她一起做动作。\n\n最令人惊讶的是，猫咪做「猫式伸展」的时候屁股翘得老高，下犬式的时候身体延展得比主人还要到位。小美将这些画面拍下来制作成了一个系列视频。\n\n「有时候我动作不标准，看看它怎么做就对了」，小美笑着说。\n\n这段视频让无数铲屎官大呼可爱，也有瑜伽老师转发点评：「这只猫的猫式伸展确实很标准，脊柱的曲线非常自然」。网友们调侃：「这才是真正的猫式瑜伽」「猫教练在线教学」「我家猫只会在我做平板支撑的时候从我肚子下面钻过去」。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20sleek%20Siamese%20cat%20stretching%20gracefully%20on%20a%20yoga%20mat%20next%20to%20a%20person%20doing%20yoga%20both%20in%20downward%20dog%20pose%20bright%20airy%20room%20with%20warm%20morning%20sunlight%20soft%20cream%20walls%20and%20light%20wood%20floors%20minimalist%20wellness%20aesthetic%20harmonious%20and%20serene%20pet%20lifestyle%20photography&width=600&height=400&seq=article-cat-yoga&orientation=landscape",
    date: "2026-08-01",
    readTime: "3分钟",
    views: 134000,
    tags: ["暹罗猫", "瑜伽", "日常"],
    featured: false,
  },
  {
    id: 9,
    title: "当猫咪第一次见到下雪，激动到模糊",
    slug: "cat-sees-snow-first-time",
    category: "duanpian",
    excerpt: "一只南方猫咪第一次见到雪的反应让主人笑疯了——它兴奋地在雪地里打滚、追逐雪花、甚至试图用爪子接住每一片雪。",
    content: "生活在南方的铲屎官带着猫咪去北方旅行，这只从没见过雪的猫咪第一次看到漫天飞舞的雪花时，眼睛瞪得像铜铃。\n\n它先是在窗台上歪着头看了半天，然后迫不及待地冲到院子里。在雪地里，猫咪完全释放了自己——打滚、跳跃、追逐飘落的雪花、把头埋进雪堆里再猛地抬起来，雪花四溅的瞬间被主人完美抓拍。\n\n短短三分钟的视频里，猫咪的每一个动作都充满了纯真的快乐，让观众也跟着开心起来。\n\n「看着它在雪地里那么开心，感觉所有烦恼都被治愈了」「南方猫咪的雪地初体验，太珍贵了」「它比我家孩子玩雪还兴奋」。\n\n温馨提醒：带猫咪去寒冷的地方要注意保暖，玩耍时间不宜过长，回家后要及时擦干爪子和毛发。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20fluffy%20orange%20cat%20playing%20joyfully%20in%20fresh%20white%20snow%20snowflakes%20falling%20around%20the%20cat%20mid%20jump%20with%20paws%20reaching%20up%20to%20catch%20snowflakes%20bright%20winter%20daylight%20soft%20cream%20and%20white%20color%20palette%20magical%20and%20whimsical%20winter%20wonderland%20atmosphere%20joyful%20pet%20action%20photography%20with%20crisp%20detail&width=800&height=450&seq=article-cat-sees-snow&orientation=landscape",
    date: "2026-07-31",
    readTime: "3分钟",
    views: 201000,
    tags: ["下雪", "初体验", "欢乐"],
    featured: true,
  },
  {
    id: 10,
    title: "猫咪为什么喜欢纸箱？科学解释来了",
    slug: "why-cats-love-boxes",
    category: "catknowledge",
    excerpt: "几乎所有的猫咪都无法抗拒纸箱的诱惑，这背后究竟有什么科学原因？让我们一起来揭秘猫咪的纸箱情结。",
    content: "你花大价钱买的猫窝猫咪不屑一顾，但一个快递纸箱却能让它玩上三天三夜。这不是你养了只假猫，而是几乎所有猫咪的共性。\n\n科学研究表明，猫咪喜欢纸箱主要有以下几个原因：\n\n第一，安全感。纸箱提供了一个三面封闭的空间，让猫咪感觉自己处于一个安全的「洞穴」中。在野外，猫咪的天敌较少，但防范意识是天生的。\n\n第二，温度适宜。纸箱的隔热性能好，猫咪蜷缩在里面可以很好地保持体温。猫咪最舒适的环境温度比人类高，纸箱正好提供了一个小型的温暖空间。\n\n第三，减压。研究表明，收容所里的猫咪如果有纸箱可以躲藏，压力水平明显低于没有纸箱的猫咪。\n\n第四，狩猎本能。纸箱为猫咪提供了一个绝佳的「埋伏点」，它们可以躲在里面观察外面的「猎物」，然后突然出击。\n\n所以下次收到快递，别急着把纸箱扔掉，你的猫咪可能会因此开心一整天！",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20happy%20calico%20cat%20peeking%20out%20from%20inside%20a%20cardboard%20box%20with%20curious%20bright%20eyes%20soft%20warm%20studio%20lighting%20clean%20cream%20and%20beige%20background%20playful%20and%20cozy%20atmosphere%20professional%20pet%20photography%20with%20shallow%20depth%20of%20field%20minimalist%20composition%20with%20warm%20tones&width=600&height=400&seq=article-cats-love-boxes&orientation=landscape",
    date: "2026-07-30",
    readTime: "5分钟",
    views: 67000,
    tags: ["科普", "猫咪行为", "纸箱"],
    featured: false,
  },
  {
    id: 11,
    title: "猫咪看恐怖片的反应笑翻网友，胆子比主人还小",
    slug: "cat-watches-horror-movie",
    category: "gaoxiao",
    excerpt: "主人作死带着猫咪一起看恐怖片，结果猫咪全程躲在抱枕后面，遇到惊吓镜头直接弹跳起飞，比主人反应还夸张。",
    content: "一位铲屎官突发奇想，想看看自家猫咪对恐怖片的反应，于是打开了经典恐怖片。没想到猫咪的胆子比他还小。\n\n视频一开始，猫咪还悠闲地趴在沙发上。当第一个惊吓镜头出现时，猫咪直接炸毛弹了起来，然后迅速躲到了沙发靠垫后面。接下来整个观影过程中，猫咪全程躲在抱枕后面，只露出一双警惕的大眼睛，每当音效变得紧张时，耳朵就向后贴紧。\n\n最搞笑的是，在电影最高潮的部分，一个突然出现的画面把猫咪吓得直接跳下了沙发，以百米冲刺的速度跑到了另一个房间。\n\n网友评论：「对不起猫猫但是我真的笑疯了」「猫咪后来跟你算账了吗」「这猫的胆子跟它的体型成反比」「建议下次带它看动画片」。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20fluffy%20black%20and%20white%20cat%20with%20wide%20frightened%20eyes%20hiding%20behind%20a%20sofa%20cushion%20only%20eyes%20and%20ears%20peeking%20out%20TV%20glow%20in%20background%20dimly%20lit%20cozy%20living%20room%20humorous%20and%20dramatic%20pet%20photography%20warm%20interior%20tones%20with%20blue%20TV%20light%20contrast%20playful%20scared%20cat%20expression&width=600&height=400&seq=article-cat-horror&orientation=landscape",
    date: "2026-07-29",
    readTime: "3分钟",
    views: 245000,
    tags: ["搞笑", "恐怖片", "胆小"],
    featured: false,
  },
  {
    id: 12,
    title: "猫咪按摩师上线：每天给主人踩背按摩",
    slug: "cat-gives-massage",
    category: "zhiyu",
    excerpt: "这只猫咪自学成才，每天都会在主人背上用爪子有节奏地踩来踩去，俨然一副专业按摩师的架势。",
    content: "「我觉得它上辈子可能是个按摩师。」一位铲屎官这样描述自家的猫咪。这只名叫豆豆的猫咪有一个特殊的习惯——每当主人趴在沙发上或者床上，它就会跳上来，用两只前爪在主人背上有节奏地踩压。\n\n豆豆的「按摩」非常有规律，通常是先踩肩颈部位，然后沿着脊柱两侧向下，最后在腰部来回踩几轮，整套「服务」大约持续15分钟。主人说：「它的力道恰到好处，不轻不重，真的能缓解疲劳。」\n\n宠物行为专家解释，猫咪踩奶（kneading）是幼猫时期刺激母猫乳汁分泌的本能行为，成年后这种行为通常表示放松和满足。有些猫咪会把这种安抚行为用在主人身上，是信任和亲近的表现。\n\n这段视频让无数网友羡慕不已：「我的猫只会踩我的脸」「这服务太上头了」「建议开个猫咪按摩店，我第一个预约」。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20cute%20tabby%20cat%20standing%20on%20a%20persons%20back%20with%20paws%20rhythmically%20pressing%20like%20a%20professional%20massage%20soft%20warm%20bedroom%20lighting%20cream%20and%20beige%20cozy%20atmosphere%20calm%20and%20therapeutic%20pet%20interaction%20photography%20top%20down%20angle%20clean%20and%20minimalist%20composition%20with%20gentle%20tones&width=600&height=400&seq=article-cat-massage&orientation=landscape",
    date: "2026-07-28",
    readTime: "4分钟",
    views: 156000,
    tags: ["治愈", "踩奶", "按摩"],
    featured: false,
  },
];

export const faqs = [
  {
    question: "这个网站的猫咪视频都来自哪里？",
    answer: "我们的猫咪视频内容来自全网热门平台的精选合集，经过编辑团队精心筛选，确保每个视频都具有高质量和高观赏性。我们致力于为猫咪爱好者提供最优质的视频内容体验。",
  },
  {
    question: "网站的视频内容多久更新一次？",
    answer: "我们保持每日更新的频率，每天都会有新鲜有趣的猫咪视频内容上线。编辑团队全天候关注猫咪视频社区的最新动态，确保你不会错过任何精彩内容。",
  },
  {
    question: "如何快速找到我喜欢的猫咪视频类型？",
    answer: "你可以通过顶部的分类导航快速跳转到感兴趣的视频类型，包括搞笑猫咪、萌宠日常、萌猫短片、治愈猫咪、幼猫成长和养猫知识等六大分类，每个分类都有丰富的精选内容。",
  },
  {
    question: "可以在手机上观看这些猫咪视频吗？",
    answer: "当然可以！我们的网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。无论在通勤路上还是午休时间，随时随地都能享受猫咪带来的快乐。",
  },
  {
    question: "我有好玩的猫咪视频想投稿，怎么联系你们？",
    answer: "非常欢迎！你可以通过「关于我们」页面的联系方式，将你的猫咪视频素材发送给我们。如果内容符合我们的标准，我们会将你的视频收录到合集中，让更多猫咪爱好者看到。",
  },
  {
    question: "网站是免费的吗？需要注册账号吗？",
    answer: "完全免费！猫咪视频大全是一个开放的内容平台，所有视频内容都可以免费观看，无需注册或登录。我们相信快乐应该没有门槛，每一个爱猫的人都能在这里找到属于自己的治愈时光。",
  },
];

export const aboutInfo = {
  brandName: "猫咪视频大全",
  brandIntro: "猫咪视频大全成立于2024年，是国内领先的猫咪视频内容聚合平台。我们汇聚全网最热门、最治愈的猫咪视频，为千万猫咪爱好者提供高品质的视听享受。无论是搞笑猫咪视频让你开怀大笑，还是治愈猫咪短视频帮你卸下一天的疲惫，这里都是你温暖的猫咪乐园。",
  mission: "我们相信，每一只猫咪都是独一无二的小天使，它们用最纯粹的方式治愈着每一个人的心灵。猫咪视频大全的使命是让更多人感受到猫咪带来的快乐与温暖，打造一个充满爱和欢笑的萌宠社区。",
  values: [
    { title: "品质至上", description: "严格筛选每一个视频内容，确保品质和原创性" },
    { title: "每日更新", description: "编辑团队每日精选最新最热的猫咪视频，让你每天都有新发现" },
    { title: "用户至上", description: "以用户需求为导向，持续优化浏览体验和内容推荐" },
    { title: "热爱驱动", description: "团队的每一位成员都是资深猫奴，用心做好每一个内容" },
  ],
  stats: [
    { number: "10,000+", label: "精选视频" },
    { number: "6大", label: "内容分类" },
    { number: "500万+", label: "月活用户" },
    { number: "98%", label: "用户好评率" },
  ],
  contact: {
    email: "hello@catvideo.cn",
    wechat: "CatVideo2024",
    address: "浙江省杭州市余杭区未来科技城猫咪大厦",
  },
  testimonials: [
    {
      name: "猫奴小李",
      avatar: "小",
      content: "每天上班压力很大，午休的时候看看猫咪视频大全，真的能治愈一整天的疲惫！尤其是搞笑猫咪那个分类，笑到停不下来。",
      role: "资深铲屎官",
    },
    {
      name: "奶茶妈妈",
      avatar: "奶",
      content: "我家猫咪特别喜欢看网站上的幼猫视频，每次播放它都会跳到电脑前面认真观看，场面特别搞笑。",
      role: "三猫家庭家长",
    },
    {
      name: "程序员阿杰",
      avatar: "程",
      content: "写代码写到崩溃的时候，打开猫咪视频大全刷几条，瞬间回血。同事都问我为什么工作效率这么高，我说我有秘密武器。",
      role: "互联网从业者",
    },
    {
      name: "退休教师王阿姨",
      avatar: "王",
      content: "退休后学会了上网，偶然发现了这个网站，现在每天都要看好几个小时。猫咪们太可爱了，让我的退休生活充满了乐趣。",
      role: "退休教师",
    },
  ],
};